import React from 'react';
import { Typography } from '@mui/material';

export const CapFirst = (props: any) => (
  <Typography sx={{ '::first-letter': { textTransform: 'capitalize' } }} {...props}>
    {props.content}
  </Typography>
);
